
import { Component, Vue } from "vue-property-decorator";
import { Emotion, Scene } from "./interfaces/Interfaces";
import DisplayController from "./components/DisplayController.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import axios, { AxiosResponse } from "axios";

@Component({
  components: {
    DisplayController,
  },
  methods: {
    ...mapActions("stimulus", {
      fetchEmotions: "fetchEmotions",
    }),
  },
  computed: {
    ...mapGetters("stimulus", {
      getEmotions: "getEmotions",
      getEmotionsWithFilters: "getEmotionsWithFilters",
    }),
    ...mapGetters("scenes", {
      getScenes: "getScenes",
    }),
    ...mapGetters("stimulus", {
      getProjectName: "getProjectName",
    }),
    ...mapGetters("stimulus", {
      getVideoName: "getVideoName",
    }),
  },
})
export default class App extends Vue {
  private getEmotions!: Emotion[] | [];
  private getEmotionsWithFilters!: Emotion[] | [];
  private fetchEmotions!: () => Scene[] | [];
  private getProjectName!: string;
  private getVideoName!: string;

  private created() {
    this.fetchEmotions();
  }
}
